import type {Ref} from 'vue';
import {computed, ref} from 'vue';
import {businessReferralsEndpoints} from '@registry';
import {defineStore} from 'pinia';
import type {BusinessReferralWebPreferencesResource} from '~/openapi';

export const usePreferencesStore = defineStore('preferences-store', () => {
    const preferences: Ref<BusinessReferralWebPreferencesResource> = ref({onboardingAcknowledged: true});

    async function fetchBusinessReferralWebPreferences() {
        preferences.value = await businessReferralsEndpoints.getBusinessReferralWebPreferences();
    }

    async function acknowledgeOnboarding() {
        await businessReferralsEndpoints.acknowledgeOnboarding();
        await fetchBusinessReferralWebPreferences();
    }

    return {
        preferences: computed(() => preferences.value),
        fetchBusinessReferralWebPreferences,
        acknowledgeOnboarding,
    };
});
